import {
  useReferentialNotifications,
  groupNotificationsByType,
} from "@/entities/referential/referential-notifications";
import { useGetSettingsNotifications } from "@/entities/settings";
import { AppLoading } from "@/ui/app-loading";

import { UserPreferencesNotifications } from "./user-preferences-notifications.component";

export const UserPreferencesNotificationsWrapper = () => {
  const { isLoading: isLoadingReferential, notifications } =
    useReferentialNotifications();
  const { isLoading: isLoadingSettings, userPreferencesNotifications } =
    useGetSettingsNotifications();

  if (isLoadingReferential || isLoadingSettings) {
    return <AppLoading />;
  }

  const notificationsByType = groupNotificationsByType(notifications);

  return (
    <UserPreferencesNotifications
      notificationsByType={notificationsByType}
      userPreferencesNotifications={userPreferencesNotifications}
    />
  );
};
